import Typography from '@mui/material/Typography';
import React, { useMemo } from 'react';
import { Tag, X } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import { Tag as TagType } from 'shared/types/tag';

import * as Styled from './filter-banner-base.style';

export type FilterBannerBaseProps = {
  tags: TagType[];
  onTags: (e: React.MouseEvent) => void;
  onClear: () => void;
};

export const FilterBannerBase: React.FC<FilterBannerBaseProps> = ({
  tags,
  onTags,
  onClear,
}) => {
  const filterTagNames = useMemo(
    () => tags.map(({ name }) => name).join(', '),
    [tags],
  );

  return (
    <Styled.Container $open={!!filterTagNames.length}>
      <Styled.Content>
        <Styled.TagsContainer onClick={onTags}>
          <Styled.IconContainer>
            <Icon icon={Tag} />
          </Styled.IconContainer>
          <Typography variant="buttonSmall" component="span">
            {filterTagNames}
          </Typography>
        </Styled.TagsContainer>

        <Styled.ClearButton onClick={onClear}>
          <Icon icon={X} />
        </Styled.ClearButton>
      </Styled.Content>
    </Styled.Container>
  );
};
